export function isInternetExplorer() {
    return window.navigator.userAgent.indexOf('MSIE ') > 0;
}
//# sourceMappingURL=browser.js.map